(function (t) {
// da
t.add("label_previous", "Forrige", "KnpPaginatorBundle", "da");
t.add("label_next", "N\u00e6ste", "KnpPaginatorBundle", "da");
})(Translator);
